var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pagefra',[_c('div',{staticClass:"servicePackage"}),_c('ServicePackage',{attrs:{"visible":_vm.dialogVisible},on:{"close":_vm.closeTab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }